import { formatDate } from "@/utils/date";
//价格拼￥
let getAmount = amount => {
  if (amount) {
    return "￥" + amount;
  }
  return "￥" + "0.00";
};

//价格保留两位小数
let toFixedAmount = amount => {
  const price = amount * 1;
  return "￥" + price.toFixed(2);
};

//结算方式
let settlementMode = mode => {
  switch (mode) {
    case 0:
      return "次结";
    case 1:
      return "月结";
    case 2:
      return "季结";
    case 3:
      return "半年结";
    case 4:
      return "年结";
    default:
      return "";
  }
};

//开票状态
let recordStatus = state => {
  if (state == 0) {
    return "未申请";
  } else if (state == 10) {
    return "已提交";
  } else if (state == 1) {
    return "开票中";
  } else if (state == 11) {
    return "已确认";
  } else if (state == 2) {
    return "已开票";
  } else if (state == -1) {
    return "财务驳回";
  } else if (state == -2) {
    return "退票中";
  } else if (state == -3) {
    return "已退票";
  } else if (state == -4) {
    return "销售驳回";
  } else if (state == -5) {
    return "客户申请退票中";
  } else if (state == -6) {
    return "已取消";
  } else if (state == -8) {
    return "财务驳回退票";
  } else if (state == -7) {
    return "销售驳回退票";
  } else {
    return "";
  }
};

// 发票类型
let receiptType = info => {
  // console.log('***********************----------------------')
  // console.log(info.receiptCategory,info.sendType)
  let receiptCategory = info.receiptCategory;
  let sendType = info.sendType;
  if (receiptCategory == 0 && sendType == 0) {
    return "纸质普票";
  } else if (receiptCategory == 1 && sendType == 0) {
    return "纸质专票";
  } else if (receiptCategory == 0 && sendType == 2) {
    return "电子普票";
  } else if (receiptCategory == 1 && sendType == 2) {
    return "电子专票";
  } else {
    return "";
  }
};

//用户身份
let getUserJob = job => {
  switch (job) {
    case 0:
      return "学生";
    case 1:
      return "教职工";
    case 2:
      return "企业";
    case 3:
      return "医院";
    case 4:
      return "个人";
    case 5:
      return "事业单位";
    default:
      return "";
  }
};

//上传下载报告 操作类型
let operateType = type => {
  if (type == 0) {
    return "前台下载";
  } else if (type == 2) {
    return "下载";
  } else if (type == 3) {
    return "删除";
  } else if (type == 1) {
    return "上传";
  }
};
//上传下载报告 操作人
let createUser = info => {
  //类型是前台下载时  显示用户二字
  if (info.operateType == 0) {
    return "用户";
  } else {
    return info.createUser;
  }
};

//信用金审核状态
let reviewStatus = status => {
  switch (status) {
    case 0:
      return "未处理";
    case 1:
      return "已通过";
    case 2:
      return "已驳回";
    default:
      return "";
  }
};
//信用金审核状态
let reviewClass = status => {
  switch (status) {
    case 0:
      return "status state_icon0";
    case 1:
      return "status state_icon1";
    case -1:
      return "status state_icon2";
    default:
      return "";
  }
};
//申请信用金  用户学历
let educational = educational => {
  if (educational === 0) {
    return "本科";
  } else if (educational === 1) {
    return "硕士";
  } else if (educational === 2) {
    return "博士";
  } else if (educational === -1) {
    return "专科";
  }
};
//信用金  根据学历判断模态框第二标题显示内容
let secondTitle = title => {
  if (title === 0) {
    return "导师信息";
  } else if (title === 1) {
    return "课题组负责人信息";
  } else if (title === 2) {
    return "部门负责人信息";
  } else if (title === 3) {
    return "部门负责人信息";
  } else if (title === 4) {
    return "个人";
  }
};

//会员福利
let memberLevelWelfareList = list => {
  let str = "";
  // 福利类型（1积分，2优惠券，3授信额度，4测试金额与积分兑换比例）
  if (list) {
    list.forEach(item => {
      if (item.welfareType === 1) {
        str += item.welfareValue + "积分 ";
      } else if (item.welfareType === 2) {
        str += item.welfareDesc + "的优惠券 ";
      } else if (item.welfareType === 3) {
        str += item.welfareValue + "授信额度 ";
      } else if (item.welfareType === 4) {
        str += "1元=" + item.welfareValue + "积分";
      }
    });
  }

  return str;
};
//会员条件
let limitAmount = amount => {
  // 福利类型（1积分，2优惠券，3授信额度，4测试金额与积分兑换比例）
  let str = "";
  if (amount == 0) {
    str = "免费注册即可成为";
  } else {
    str = "测试金额累计达" + amount + "元";
  }
  return str;
};

// 积分商品类别
let pointGoodsClass = type => {
  if (type == 0) {
    return "电子卡劵";
  } else if (type == 1) {
    return "实物";
  } else if (type == 2) {
    return "试验金";
  } else if (type == 3) {
    return "测试券";
  } else {
    return "N/A";
  }
};
// 积分审核状态
let pointAduitStatusFilter = value => {
  if (value == 0) {
    return "审核中";
  } else if (value == 10) {
    return "已审核";
  } else if (value == 20) {
    return "无需审核";
  } else if (value == -1) {
    return "已驳回";
  }
};

//积分收入/支出
let incomeExpenditureChange = value => {
  if (value >= 0) {
    return "+" + value;
  } else if (value < 0) {
    return value;
  } else {
    return "N/A";
  }
};

// 过滤列表中未存在的字段
let tableNoExistField = value => {
  if (value) {
    return value;
  } else {
    return "";
  }
};
// 过滤列表中未存在的字段
let settleState = value => {
  if (value) {
    return "已结算";
  } else {
    return "未结算";
  }
};
// texts: ['非常差', '差', '一般', '好', '非常好'],
//订单评价分数
let score = value => {
  if (value == 5) {
    return "非常好";
  } else if (value == 1) {
    return "非常差";
  } else if (value == 2) {
    return "差";
  } else if (value == 3) {
    return "一般";
  } else if (value == 4) {
    return "好";
  }
  return value ? value : "";
};
//支付方式
let payType = (value, row) => {
  let result = "";
  if (value == 1) {
    result = "微信支付";
  } else if (value == 2) {
    result = "支付宝支付";
  } else if (value == 3) {
    result = "信用金支付";
  } else if (value == 4) {
    if (
      row.chinaumsRealPayType === "Alipay 2.0" ||
      row.chinaumsRealPayType === "Alipay 1.0"
    ) {
      result = "易收宝-支付宝";
    } else if (row.chinaumsRealPayType === "WXPay") {
      result = "易收宝-微信";
    } else if (row.chinaumsRealPayType === "JD") {
      result = "易收宝-京东";
    } else if (row.chinaumsRealPayType === "BaiDu") {
      result = "易收宝-百度";
    } else if (row.chinaumsRealPayType === "ACP") {
      result = "易收宝-银联立码付";
    } else if (row.chinaumsRealPayType === "YQB") {
      result = "易收宝-壹钱包";
    } else if (row.chinaumsRealPayType === "QMF") {
      result = "易收宝-全民付";
    } else {
      result = "易收宝-其他";
    }
  } else if (value == 5) {
    result = "余额支付";
  } else if (value == 0) {
    result = "未支付";
  } else if (value == 7) {
    let str = "";
    if (row.balancePayType == 10) {
      str += "个人账户-";
    }
    if (row.balancePayType == 20) {
      str += "共享账户-";
    }
    if (row.otherPayType == 1) {
      str += "微信";
    } else if (row.otherPayType == 2) {
      str += "支付宝";
    } else if (row.otherPayType == 3) {
      str += "信用金";
    } else if (row.otherPayType == 4) {
      str += "易收宝";
    } else if (row.otherPayType == 6) {
      str += "对公转账";
    }
    result = str;
  } else if (value == 5) {
    result = "余额";
  } else if (value == 6) {
    result = "对公转账";
  }
  return result;
};

//退款流水支付方式
let refundPayTypeTextFilter = type => {
  if (type == 0) {
    return "未支付";
  } else if (type == 1) {
    return "微信";
  } else if (type == 2) {
    return "支付宝";
  } else if (type == 3) {
    return "信用金";
  } else if (type == 4) {
    return "银联商务支付";
  } else if (type == 5) {
    return "余额支付";
  } else if (type == 6) {
    return "对公转账";
  } else if (type == 7) {
    return "组合支付";
  } else {
    return "";
  }
};

//预存支付方式
let prestoredPayMethod = type => {
  if (type == 1) {
    return "微信支付";
  } else if (type == 2) {
    return "支付宝支付";
  } else if (type == 6) {
    return "对公转账";
  } else {
    return "";
  }
};

// 奖品类型
let giftTypeFilter = type => {
  if (type == 1) {
    return "积分";
  } else if (type == 2) {
    return "实物";
  } else if (type == 3) {
    return "优惠劵";
  } else if (type == 4) {
    return "京东卡";
  } else if (type == 0) {
    return "谢谢惠顾";
  } else {
    return "";
  }
};

// 奖品状态
let giftStatus = status => {
  if (status == 1) {
    return "待送出";
  } else if (status == 2) {
    return "已送出";
  } else {
    return "放弃奖品";
  }
};

//预存消费种类
let prestoredConsumeTypeFilter = type => {
  if (type == 10) {
    return "充值";
  } else if (type == 20) {
    return "下单";
  } else if (type == 30) {
    return "还款";
  } else if (type == 40) {
    return "订单退款";
  } else if (type == 50) {
    return "转出个人账户";
  } else if (type == 60) {
    return "转入共享账户";
  } else if (type == 70) {
    return "预存退款";
  } else if (type == 80) {
    return "迁移5.0";
  }
  else {
    return "";
  }
};
// 预存支付状态
let prestoredRefundPayStatus = () => {
  if (type == 10) {
    return "未退款";
  } else if (type == 20) {
    return "部分退款";
  } else if (type == 30) {
    return "退款失败";
  } else if (type == 40) {
    return "已退款";
  } else if (type == -1) {
    return "已取消";
  }
};
// 中奖概率显示格式化(*100 + %)
let lotteryProbabilityShowText = value => {
  if (typeof value === "number") {
    return value * 100 + "%";
  } else {
    return value;
  }
};
let paymentPayType = value => {
  if (value == 1) {
    return "微信收款";
  } else if (value == 2) {
    return "支付宝收款";
  } else if (value == 3) {
    return "对公转转账收款";
  }
};
let paymentDrawStatus = value => {
  if (value == 1) {
    return "已领取";
  } else if (value == 0) {
    return "未领取";
  }
};
let paymentDrawFinishStatus = value => {
  if (value == -1) {
    return "待分配";
  } else if (value == 0) {
    return "分配中";
  } else if (value == 1) {
    return "已分配";
  }
};
let detailType = value => {
  if (value == 1) {
    return "个人账户";
  } else if (value == 2) {
    return "共享账户";
  } else if (value == 3) {
    return "订单还款";
  } else if (value == 4) {
    return "微信/支付宝直接支付订单";
  } else if (value == 5) {
    return "取消订单回调";
  } else if (value == 6) {
    return "对公转账";
  } else {
    return "";
  }
};
//发票状态
let orderReceiptStatus = status => {
  if (status == 0) {
    return "未申请";
  } else if (status == 10) {
    return "已提交";
  } else if (status == 1) {
    return "开票中";
  } else if (status == 11) {
    return "已确认";
  } else if (status == 2) {
    return "已开票";
  } else if (status == -1) {
    return "已驳回";
  } else if (status == -2) {
    return "退票中";
  } else if (status == -3) {
    return "已退票";
  }
};

let paybackStatus = status => {
  if (status === 0) {
    return "未还款";
  } else if (status === 1) {
    return "已到账";
  } else if (status === 3) {
    return "还款中-分配中";
  } else if (status === 2) {
    return "还款中-未分配";
  } else if (status === -1) {
    return "非信用付";
  }
  return "非信用付";
};
//对公款项状态
let transferPayStatus = status => {
  if (status === -1) {
    return "非对公";
  } else if (status === 1) {
    return "已到账";
  } else if (status === 0) {
    return "未分配";
  } else if (status === 2) {
    return "待审核";
  } else if (status === 3) {
    return "分配中";
  } else if (status === 4) {
    return "部分到账";
  }
  return "非对公";
};
let timeSplit = value => {
  return value ? value.split(" ")[0] : value;
};
let deviceSource = value => {
  if (value === 0) {
    return "材料测试";
  } else if (value === 1) {
    return "云现场";
  } else if (value === 2) {
    return "成分分析";
  }
};
// 科研文库-文章状态
let articleStatus = status => {
  if (status == 0) {
    return "未发布";
  } else if (status == 1) {
    return "已发布";
  } else if (status == -1) {
    return "已删除";
  }
};

let transferPayType = value => {
  if (value === 10) {
    return "对公转账";
  }
  return "信用付";
};

let listConfigRemindType = type => {
  if (type === "10") {
    return "行底色";
  } else if (type === "20") {
    return "字体颜色";
  }
};

// 售后是否解决
let saleAfterIsResolved = status => {
  if (status === "Y") {
    return "已解决";
  } else if (status === " N") {
    return "未解决";
  }
};

// 供应商结算状态
let supSettlementStatus = status => {
  if (status === 0) {
    return "未结算";
  } else {
    return "已结算";
  }
};

// 积分审核状态
let pointsReviewStatus = status => {
  if (status === 0) {
    return "未审核";
  } else if (status === 1) {
    return "已通过";
  } else if (status === -1) {
    return "已驳回";
  } else {
    return "";
  }
};

//退款流水——格式化时间
let refundFormatDateTime = time => {
  if (time == null || time === "") {
    return "N/A";
  }
  let date = new Date(time);
  return formatDate(date, "yyyy-MM-dd hh:mm:ss");
};

//退款流水——格式化金额
let refundFormatAmount = amount => {
  if (amount != undefined || amount != null) {
    return "￥" + amount;
  } else {
    return "";
  }
};

//退款流水——发票状态
let refundReceiptStatus = status => {
  if (status === 0) {
    return "未申请";
  } else if (status === 1) {
    return "开票中";
  } else if (status === 2) {
    return "已开票";
  } else if (status === -1) {
    return "已驳回";
  } else {
    return "";
  }
};

//退款流水——订单状态
let refundOrderStatus = status => {
  if (status === 1) {
    return "待支付";
  } else if (status === 2) {
    return "待实验";
  } else if (status === 3) {
    return "实验中";
  } else if (status === 4) {
    return "已完成";
  } else if (status === -1) {
    return "已取消";
  } else {
    return "";
  }
};

// 订单状态
let orderStatus = status => {
  if (status == -1) {
    return "已取消";
  } else if (status == 1) {
    return "待支付";
  } else if (status == 2) {
    return "待试验";
  } else if (status == 3) {
    return "实验中";
  } else if (status == 4) {
    return "已完成";
  } else if (status == 19) {
    return "待审核";
  }
  return "";
};
// 订单款项状态
let orderPaymentStatus = status => {
  if (status == 10) {
    return "未到账";
  } else if (status == 20) {
    return "已到账";
  } else if (status == 30) {
    return "部分到账";
  }
  return "";
};
// 返利类型
let rebateType = status => {
  if (status === "inviter") {
    return "邀请返利";
  } else if (status === "invitee") {
    return "订单返利";
  }
  return "";
};

//订单变更记录审核状态
let orderChangeReviewStatus = status => {
  if (status === "10") {
    return "待审核";
  } else if (status === "20") {
    return "通过";
  } else if (status === "30") {
    return "驳回";
  }
};

//服务类型
let orderPeriodLevel = status => {
  if (status === 2) {
    return "加急";
  } else if (status === 3) {
    return "特急";
  }
  return "常规";
};
//是否
let isTrue = status => {
  if (status) {
    return "是";
  }
  return "否";
};
//样品状态
let sampleStatus = status => {
  if (status == 1) {
    return "已收样";
  }
  if (status == 2) {
    return "已寄样";
  }
  if (status == 3) {
    return "已退样";
  }
  if (status == 0) {
    return "未收样";
  }
};

let retestStatus = status => {
  if (status == 0) {
    return "非复测订单";
  } else if (status == 10) {
    return "复测中";
  } else if (status == 20) {
    return "复测完成";
  }

  return "未设置";
};

//订单数据报告
let dataResultTypeFilter = info => {
  let res = "";
  if (info) {
    let temp = info.split(",");
    if (temp.length == 1) {
      temp[0] == "1" ? (res = "数据") : (res = "报告");
    } else {
      res = "数据 报告";
    }
  }
  return res;
};
const obj = {
  getAmount, //价格拼￥
  settlementMode, //供应商结算方式
  recordStatus, //开票状态
  toFixedAmount, //保留两位小数
  receiptType, //发票类型
  getUserJob, //用户身份
  operateType, //上传下载报告 操作类型
  createUser, //上传下载报告 操作人
  reviewStatus, //信用金审核状态
  reviewClass, //信用金审核状态
  educational, //用户学历
  secondTitle, //信用金  根据学历判断模态框第二标题显示内容
  memberLevelWelfareList, //会员福利
  limitAmount, //会员条件
  pointGoodsClass, //积分商品类别
  incomeExpenditureChange, //积分收入-支出
  pointsReviewStatus, //积分审核状态
  tableNoExistField, //过滤列表中未存在的字段
  pointAduitStatusFilter, //积分审核状态
  settleState, //结算状态
  score, //评价分数
  prestoredPayMethod, //预存支付方式
  payType, //订单支付方式
  giftTypeFilter, //奖品类型
  giftStatus, //奖品状态
  lotteryProbabilityShowText, // 中奖概率显示格式化(*100 + %)
  paymentDrawStatus, //到款领取状态
  paymentDrawFinishStatus, //到款分配状态
  paymentPayType, //到款的支付方式
  detailType, //到款分配
  orderReceiptStatus, //订单发票状态
  paybackStatus, //订单还款状态
  timeSplit,
  prestoredConsumeTypeFilter, //预存消费种类
  prestoredRefundPayStatus, //预存支付状态
  deviceSource, //仪器类别
  transferPayStatus, //对公转账状态
  transferPayType, //订单分配类型
  articleStatus,
  listConfigRemindType, //列表配置提示方式
  saleAfterIsResolved,
  supSettlementStatus,
  refundFormatDateTime,
  refundFormatAmount,
  refundPayTypeTextFilter,
  refundReceiptStatus,
  refundOrderStatus,
  orderStatus, //订单状态
  orderPaymentStatus, //订单款项状态
  rebateType, //返利类型
  orderChangeReviewStatus,
  orderPeriodLevel, //服务类型
  isTrue,
  sampleStatus,
  retestStatus, // 订单复测状态
  dataResultTypeFilter //订单数据报告
};
//订单详情，判断要素解锁为下载文件还是结果
export default obj;



// WEBPACK FOOTER //
// ./src/common/filter.js